import enumeration from "./enumeration";

const SyncStatus = {
  PROCESSING: "processing",
  FAILED: "failed",
  DISCONNECTED: "disconnected",
};

export default enumeration(SyncStatus);
